import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Link, Toolbar, Typography, Box, Container, Button } from '@mui/material';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';

export const Header = ({ onOpenMigrationNotice }) => {

    return (
        <React.Fragment>
            <AppBar 
                position='fixed' 
                elevation={0}
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    bgcolor: '#FFFFFF',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Container maxWidth="xl">
                    <Toolbar disableGutters sx={{ minHeight: { xs: '64px', sm: '72px' } }}>
                        <Link 
                            component={RouterLink} 
                            underline='none' 
                            to='/'
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                            }}
                        >
                            <Box
                                component="img"
                                src="/img/icon.svg"
                                alt="EOE Logo"
                                sx={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 0,
                                    display: 'block',
                                    objectFit: 'cover',
                                    boxShadow: 'none',
                                }}
                            />
                            <Typography 
                                variant="h6" 
                                sx={{ 
                                    fontWeight: 600,
                                    color: 'text.primary',
                                    letterSpacing: '-0.02em',
                                    display: { xs: 'none', sm: 'block' }
                                }}
                            >
                                EOE字幕库
                            </Typography>
                        </Link>
                        
                        <Box sx={{ flexGrow: 1 }} />
                        <Button
                            size='small'
                            variant='outlined'
                            startIcon={<CampaignOutlinedIcon />}
                            onClick={onOpenMigrationNotice}
                            sx={{
                                borderRadius: '999px',
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 1.5,
                                display: { xs: 'none', sm: 'inline-flex' }
                            }}
                        >
                            切片功能迁移说明
                        </Button>
                        <Button
                            size='small'
                            variant='outlined'
                            onClick={onOpenMigrationNotice}
                            sx={{
                                minWidth: 'auto',
                                borderRadius: '999px',
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 1.25,
                                display: { xs: 'inline-flex', sm: 'none' }
                            }}
                        >
                            迁移说明
                        </Button>

                    </Toolbar>
                </Container>
            </AppBar>
            <Toolbar sx={{ minHeight: { xs: '64px', sm: '72px' } }} />
        </React.Fragment>
    )
}